import { useCallback, useEffect, useState } from "react";
import { appAreaIntialForm, appAreaErrorForm } from "client/Components/Administraton/utils/constant";
import AppArea from "./AppArea";
import userManageOperations from '../../../../../../redux/UserManagement/operations'
import userManageSelectors from '../../../../../../redux/UserManagement/selectors'
import ConfirmationBee from '../../../../../assets/images/ConfirmationBee.svg'
import SuccessBee from '../../../../../assets/images/SuccessBee.svg'
import { useDispatch, useSelector } from "react-redux";
import { SetAddAppArea, setAppAreaById, setCheckAppArea, setDeleteAppArea } from "redux/UserManagement/action";
import { popupInitialData } from "utils";
import { commonPopupDisplay } from "client/Components/Administraton/utils/AdministrationUtils";

const AppAreaContainer = () => {
  const [appAreaForm, setAppAreaForm] = useState<any>(appAreaIntialForm);
  const [formError, setFormError] = useState<any>(appAreaErrorForm)
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
  const [currentItem, setCurrentItem] = useState([]);
  const [selectedId, setSelectedId] = useState(0)
  const [isSubmit, setIsSubmit] = useState(false)
  const [isAdding, setIsAdding] = useState(false)
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  const [detail, setDetail] = useState<any>([])
  const dispatch = useDispatch()
  const dispatchCheckAppArea = userManageOperations.dispatchGetCheckAppArea(dispatch);
  const dispatchAddAppArea = userManageOperations.dispatchGetAddAppArea(dispatch);
  const dispatchAppAreaById = userManageOperations.dispatchAppAreaById(dispatch);
  const dispatchGetAppAreaList = userManageOperations.dispatchGetAppAreaList(dispatch);
  const dispatchDeleteAppArea = userManageOperations.dispatchDeleteAppArea(dispatch);
  const dispatchGetActiveApplication = userManageOperations.dispatchGetActiveApplication(dispatch)

  const { appAreaCheck, appAreaById, deleteAppArea, isCheck, addAppAreaVal, isAppAreaCheck, checkAppArea }: any = useSelector((state: any) => ({
    appAreaCheck: userManageSelectors.checkAppArea(state),
    appAreaById: state.UserManagement.appAreaById,
    deleteAppArea: userManageSelectors.deleteAppArea(state),
    isCheck: state.UserManagement.isCheck,
    addAppAreaVal: userManageSelectors.getaddAppAreaVal(state),
    isAppAreaCheck: userManageSelectors.isAppAreaCheck(state),
    checkAppArea: userManageSelectors.checkAppArea(state), 
  }))
  useEffect(() => {
    dispatchGetActiveApplication()
  }, [])
  useEffect(() => {
    if (appAreaById) {
      setAppAreaForm({
        ...formError, areaName: appAreaById.applicationAreaName,
        application: { key: appAreaById?.applicationId?.toString(), value: appAreaById.applicationId?.toString() },
        areaId: appAreaById.applicationAreaCode,
        isActive: appAreaById.isActive
      })
    }
  }, [appAreaById?.id])
  const optionHandler = (evt: any, option: any, prop: any) => {
    if (option.value === "edit") {
      dispatchAppAreaById(prop.id)
      setShowCreateModal(true);

    }
    if (option.value === "delete") {
      setShowDeleteModal(true);
      setSelectedId(prop.id)
    }
    setCurrentItem(prop);
  };
  const handleDeleteModal = () => {
    setShowDeleteModal(false);
  };
  useEffect(() => {
    if (deleteAppArea) {
      setShowDeleteModal(false);
      setShowInfoModal(true)
      dispatch(setDeleteAppArea(false))
    }
  }, [deleteAppArea])
  const handleInfoModal = () => {
    setShowInfoModal(false);
    setCurrentItem([])
    setSelectedId(0)
    dispatchGetAppAreaList()
  }
  const handleCreateModal = () => {
    setShowCreateModal(false);
    if (appAreaById.hasOwnProperty("id")) {
      if (showCreateModal == true) {
        dispatch(setAppAreaById([]))
        dispatch(setAppAreaById(appAreaIntialForm))
        setFormError(appAreaErrorForm);
      }
    } else {
      if (showCreateModal == true) {
        setAppAreaForm(appAreaIntialForm);
        setFormError(appAreaErrorForm);
      }
    }
    dispatch(setCheckAppArea(true))
  };
  const handleDeleteClick = () => {
    dispatchDeleteAppArea(selectedId)
  }

  const validation: any = (name: any, value: any) => {
    let error = { ...formError };
    switch (name) {
      case "application":
        if (value === undefined || value === "" || value === null || value?.value === null) {
          error.applicationError = "Please select Application";
        } else {
          error.applicationError = "";
        }
        break;
      case "areaName":
        if (value === undefined || value === "" || value === null) {
          error.areaNameError = "Please enter Area Name";
        } else {
          error.areaNameError = "";
        }
        break;
      case "areaId":
        if (value === undefined || value === "" || value === null) {
          error.areaIdError = "Please enter App Area Code";
        } else {
          error.areaIdError = "";
        }
        break;

    }
    return error;
  }

  const handleFailurePopup = () => {
    hideDialog()
    dispatch(SetAddAppArea(0))
  }

  const handleChange = (event: any, item: any) => {
    let value = item;
    let name = event.target.getAttribute('name') || event.currentTarget.getAttribute('name')
    setAppAreaForm({ ...appAreaForm, [name]: value });
    let formValidationError: any = {};
    let formValidation = validation(name, value);
    formValidationError[name + 'Error'] = formValidation[name + 'Error']
    setFormError({ ...formError, [name + 'Error']: formValidation[name + 'Error'] })
  };

  const handleSubmit = () => {
    setIsSubmit(true)
    let valid = true;
    let formValError: any = {};
    for (let key in appAreaForm) {
      if (key != appAreaForm.isActive) {
        let formVal: any = validation(key, appAreaForm[key]);
        formValError[key + 'Error'] = formVal[key + 'Error'];
        if (formVal[key + 'Error']) {
          valid = false;
        }
      }
    }
    setFormError({ ...formValError })
    if (valid == true) {
      let filledVal: any = {
        id: appAreaById?.hasOwnProperty("id") ? appAreaById.id : 0,
        applicationId: appAreaForm.application.key,
        applicationName: appAreaById?.hasOwnProperty("id") ? "" : appAreaForm.application.text,
        applicationAreaName: appAreaForm.areaName,
        applicationAreaCode: appAreaForm.areaId,
        isActive: appAreaForm.isActive,
        applications: []
      }
      setDetail(filledVal)
    }
  }
  useEffect(() => {
    if (isSubmit && detail?.applicationAreaName) {
      dispatchCheckAppArea(detail)
    }
  }, [detail, isSubmit])
  useEffect(() => {
    if (!appAreaCheck && detail?.applicationAreaName) {
      dispatchAddAppArea(detail)
      setDetail([])
      setIsAdding(true)
    }
    else if (appAreaCheck && isSubmit) {
      let message = "App Area Name given is already exist."
      commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      setIsSubmit(false)
    }
  }, [appAreaCheck, isCheck])
  useEffect(() => {
    if (addAppAreaVal != undefined && addAppAreaVal != 0 && isSubmit) {
      if (addAppAreaVal > 0 && !checkAppArea) {
        var message: any = "";
        if((appAreaById.hasOwnProperty("id") && appAreaById.id != 0)){
          message = "App Area has been updated successfully";
        }else{
          message = `App Area has been created successfully with id ` + addAppAreaVal;
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, SuccessBee, "SUCCESS", handleClickPopup)
      } else if ((checkAppArea && addAppAreaVal == 0 && isAppAreaCheck) || (addAppAreaVal == "error")) {
        var message: any = "";
        if(addAppAreaVal == "error"){
          message = "Error Occured while processing the request."
        }else{
          message = "App Area Name given is already exist."
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      }
      setIsSubmit(false)
      setIsAdding(false)
    }
  }, [addAppAreaVal, isAdding])
  const togglePopup = () => {
    setShowCreateModal((prev: any) => !prev);
  };

  useEffect(() => {
    if (showCreateModal == true) {
      setAppAreaForm(appAreaIntialForm)
      setFormError(appAreaErrorForm);
    }
  }, [showCreateModal])
  const handleClickPopup = () => {
    hideDialog()
    dispatchGetAppAreaList()
    handleCreateModal()
    dispatch(setAppAreaById([]))
    dispatch(setAppAreaById(appAreaIntialForm))
    setFormError(appAreaErrorForm);
    dispatch(SetAddAppArea(0))
  }

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );
  
  return (
    <AppArea
      appAreaForm={appAreaForm}
      formError={formError}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      currentItem={currentItem}
      showDeleteModal={showDeleteModal}
      showCreateModal={showCreateModal}
      optionHandler={optionHandler}
      handleDeleteModal={handleDeleteModal}
      handleCreateModal={handleCreateModal}
      setAppAreaForm={setAppAreaForm}
      handleFailurePopup={handleFailurePopup}
      handleClickPopup={handleClickPopup}
      setCurrentItem={setCurrentItem}
      setShowInfoModal={setShowInfoModal}
      showInfoModal={showInfoModal}
      handleDeleteClick={handleDeleteClick}
      handleInfoModal={handleInfoModal}
      togglePopup={togglePopup}
      Popupcontent = {Popupcontent}
    />
  );
};

export default AppAreaContainer;
